import { render, staticRenderFns } from "./icon-reject.vue?vue&type=template&id=42c3b6f2&scoped=true&"
var script = {}
import style0 from "./icon-reject.vue?vue&type=style&index=0&id=42c3b6f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3b6f2",
  null
  
)

export default component.exports